import { Spinner } from '@/components/ui/Spinner'

/**
 * Aviso exibido no intervalo entre autenticar e trocar de página.
 * Corresponde ao componente "Redirecionando…" do layout de referência.
 */
export function RedirectingNotice() {
  return (
    <div
      role="status"
      className="flex items-center gap-3 rounded bg-surface px-4 py-3 shadow-card"
    >
      <Spinner size={20} className="text-brand" label={null} />
      <span className="text-[15px] font-medium text-ink">Redirecionando…</span>
    </div>
  )
}
